import { render, staticRenderFns } from "./FinalizeDialog.vue?vue&type=template&id=c42f2138&"
import script from "./FinalizeDialog.vue?vue&type=script&lang=js&"
export * from "./FinalizeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCheckbox,VCol,VContainer,VDialog,VIcon,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1923304440/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c42f2138')) {
      api.createRecord('c42f2138', component.options)
    } else {
      api.reload('c42f2138', component.options)
    }
    module.hot.accept("./FinalizeDialog.vue?vue&type=template&id=c42f2138&", function () {
      api.rerender('c42f2138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contracts/FinalizeDialog.vue"
export default component.exports